import React from 'react';
import { connect } from 'react-redux';

import { StepCounterType, SingleColorType, ComponentStageType } from '../types';

import { setBackgroundColor } from '../redux/actions/backgroundColor';
import { nextStep, previousStep } from '../redux/actions/step';

import { ContrastTestView } from '../components/ContrastTest';

import { colors } from '../constants';
import { pushToDataLayer } from '../utils';

interface IProps {
    stepDisplayNumber: number;
    totalSteps: number;
    setBackgroundColorConnect(color: SingleColorType): void;
    onNextStep(stepCounter: StepCounterType): void;
    onPreviousStep(stepCounter: StepCounterType): void;
    onCloseButtonClick?(): void;
}

interface IState {
    fadePercentage: number;
    componentStage: ComponentStageType;
}

const SLIDER_RANGE = [0, 130];

class BaseContrastTest extends React.Component<IProps, IState> {
    state: IState = {
        fadePercentage: 0,
        componentStage: 'enter',
    };

    componentDidMount() {
        this.props.setBackgroundColorConnect(colors.white);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleNextButtonClick = () => {
        pushToDataLayer(
            '2: Sleep de slider net zover naar rechts totdat je het oog nog net ziet.',
            'klaar'
        );

        this.setState({
            componentStage: 'exit',
        });
    };

    handleKeyDown = (e: KeyboardEvent) => {
        const { fadePercentage } = this.state;

        if (e.key === 'Enter') {
            this.handleNextButtonClick();
        }

        if (e.key === 'ArrowRight' && fadePercentage < SLIDER_RANGE[1]) {
            this.setState((prevState) => ({
                fadePercentage: prevState.fadePercentage + 2,
            }));
        }

        if (e.key === 'ArrowLeft' && fadePercentage > SLIDER_RANGE[0]) {
            this.setState((prevState) => ({
                fadePercentage: prevState.fadePercentage - 2,
            }));
        }
    };

    handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            fadePercentage: Number(e.target.value),
        });
    };

    handleAnimationRest = () => {
        if (this.state.componentStage === 'exit') {
            this.props.onNextStep('main');
        }
    };

    render() {
        const {
            onPreviousStep,
            onCloseButtonClick,
            stepDisplayNumber,
        } = this.props;
        const { fadePercentage, componentStage } = this.state;

        return (
            <ContrastTestView
                totalSteps={this.props.totalSteps}
                fadePercentage={fadePercentage}
                sliderRange={SLIDER_RANGE}
                componentStage={componentStage}
                onSliderChange={this.handleSliderChange}
                onNextButtonClick={this.handleNextButtonClick}
                onBackButtonClick={() => onPreviousStep('main')}
                onCloseButtonClick={onCloseButtonClick}
                onAnimationRest={this.handleAnimationRest}
                stepDisplayNumber={stepDisplayNumber}
            />
        );
    }
}

const mapDispatchToProps = {
    setBackgroundColorConnect: setBackgroundColor,
    onNextStep: nextStep,
    onPreviousStep: previousStep,
};

export const ContrastTest = connect(
    null,
    mapDispatchToProps
)(BaseContrastTest);
